import type { TeableConfig } from '@/types/teable';
import { secureLog } from '@/utils/secureLogger';

// Configurazione Teable - API key protetta su server
const teableConfig: TeableConfig = {
  baseUrl: 'https://app.teable.io/api',
  apiKey: '', // API key ora gestita dal server
  spaceId: 'spcmFobqP2uLdj9TtqR',
  promoTableId: 'tbl0SPjzwvcI4bTNJb9'
};

/**
 * Salva configurazioni (non più necessario - configurazione hardcoded)
 */
export const saveTeableConfig = (config: TeableConfig): void => {
  secureLog.info('Hardcoded configuration - save not needed');
};

/**
 * Verifica se le configurazioni sono complete (sempre true - configurazione hardcoded)
 */
export const isTeableConfigured = (): boolean => {
  return true;
};

/**
 * Ottiene la configurazione corrente
 */
export const getTeableConfig = (): TeableConfig => {
  return { ...teableConfig };
};

/**
 * Reset della configurazione (non più necessario - configurazione hardcoded)
 */
export const resetTeableConfig = (): void => {
  secureLog.info('Hardcoded configuration - reset not needed');
};